window.mmajaxcart = {
  AjaxcartOpen: function() {
    var body = $('body'),
        ajaxCart = $('.mm-ajaxcart'),
        ajaxOverlay = $('.mm-ajaxcart-overlay');

    body.addClass('mm-no-scroll');
    ajaxCart.addClass('has--opened');      
    ajaxOverlay.addClass('has--active');
  },
  AjaxcartClose: function() {
    var body = $('body'),
        ajaxCart = $('.mm-ajaxcart'),           	
        ajaxOverlay = $('.mm-ajaxcart-overlay');

    body.removeClass('mm-no-scroll');
    ajaxCart.removeClass('has--opened');      
    ajaxOverlay.removeClass('has--active');       
  },
  AjaxcartRender: function() {
    $.get('/cart?view=cart-ct', function(cart){
      $('.mm-ajaxcart').html(cart);

      const parser = new DOMParser();
      const cartHTML = parser.parseFromString(cart, 'text/html');
      const cartCount = cartHTML.querySelector('.mm-ajaxcart-header p').innerText.match(/\((\d+)\)/)?.[1]

      document.querySelectorAll('.header-cart__count').forEach( elem => elem.innerText = cartCount)
      
    })

  },
  AjaxcartChangeHandler: function(data) { 
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: data,
      success: function (cart) {
        mmajaxcart.AjaxcartRender();
        
        let CartCount = cart.item_count; 
        document.querySelectorAll('.header-cart__count').forEach((elem)=>{
          elem.innerText=cart.item_count;
        })
        $('.mm-cart-count').html(CartCount);
      }
    });
    
  },
  
  AjaxcartUpdateHandler: function(data) { 
    let formData = {
       updates:data
      };

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    }).then(cart=>{
      mmajaxcart.AjaxcartRender();
      
      let CartCount = cart.item_count; 
      document.querySelectorAll('.header-cart__count').forEach((elem)=>{
          elem.innerText=cart.item_count;
      })
      $('.mm-cart-count').html(CartCount);
    })
    .catch((error) => {
      console.error('Error:', error);
    });

    // $.ajax({
    //   url: '/cart/update.js',
    //   dataType: 'json',
    //   cache: false,
    //   type: 'post',
    //   data: formData,
    //   success: function (cart) {
    //     mmajaxcart.AjaxcartRender();
    //     var CartCount = cart.item_count; 
    //     document.querySelector('.header-cart__count').innerText=cart.item_count;
    //     $('.mm-cart-count').html(CartCount);
    //   }
    // });
    
  },
   
  AjaxcartQuantityHandler: function() {
    function updateQuantity(elem) {
      
      var UpdatedQuantity = parseInt($(elem).val()),
      QuantityLine = parseInt($(elem).attr('data-line')),
      params = { quantity: UpdatedQuantity, line: QuantityLine };

      let parent = elem.closest("[data-custom-product]")
      let customProductQnty = UpdatedQuantity;
      if(elem.closest("[data-custom-product]")){
        document.querySelectorAll("[data-custom-product]").forEach((ele)=>{
          if(ele != parent[0]){
            customProductQnty = customProductQnty + parseInt(ele.dataset.quantity);
          }
        })
        params = { };
        let parentKey = $(elem).attr('data-key')
        let addOnKey = document.querySelector("[data-addOnproduct]")

        params[parentKey] = UpdatedQuantity
        if(addOnKey)
        { 
          addOnKey = addOnKey.dataset.key
          params[addOnKey] = customProductQnty
        };
        mmajaxcart.AjaxcartUpdateHandler(params);
      }else{
        mmajaxcart.AjaxcartChangeHandler(params);
      }
      
    }

    $(document).on('change', '.quantity-input', function() {
     // debugger
      updateQuantity($(this).parent().find('.quantity-input'))
    }) 	
    $(document).on('click', '.quantity-plus', function() {
      let q = $(this).parent().find('.quantity-input').val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) + p;

      $(this).parent().find('.quantity-input').val(u)
      updateQuantity($(this).parent().find('.quantity-input'))
    })
    $(document).on('click', '.quantity-minus', function() {
      let q = $(this).parent().find('.quantity-input').val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) - p;


      // $(this).parent().find('.quantity-input').val(u).trigger('change');
      $(this).parent().find('.quantity-input').val(u)
      updateQuantity($(this).parent().find('.quantity-input'))

    })
  },
  AjaxcartRemoveItem: function() {
    $(document).on('click', '.mm-ajaxcart-remove-item', function() {
      var RemoveLine = parseInt($(this).attr('data-line')),
          params = { quantity: 0, line: RemoveLine };

      let parent = this.closest("[data-custom-product]")
      
      
      if( parent && parent.hasAttribute('data-custom-product')){
        let customProductQnty = 0;
        if(parent){
          document.querySelectorAll("[data-custom-product]").forEach((ele)=>{
            if(ele != parent){
              customProductQnty = customProductQnty + parseInt(ele.dataset.quantity);
            }
          })
          params = { };
          let parentKey = parent.dataset.key
          let addOnKey = document.querySelector("[data-addOnproduct]")
       
          params[parentKey] = 0
          if(addOnKey)
          { 
            addOnKey = addOnKey.dataset.key
            params[addOnKey] = customProductQnty
          };
          mmajaxcart.AjaxcartUpdateHandler(params);
        }
      }else{
        mmajaxcart.AjaxcartChangeHandler(params);
      }
      
    })
  },
  Ajaxupsell: function(){
    $(document).off('click.mmajaxcartUpsell', '.add-to-cart');
    $(document).on('click.mmajaxcartUpsell', '.add-to-cart', function() {
      var variantId = $(this).attr('data-variantids')
      var data = {
        id: variantId,
        quantity: 1
      };
      fetch('/cart/add.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST'
      }).then(function(response) {
        return response.json();
      }).then(function(json) {
        mmajaxcart.AjaxcartOpen();
        mmajaxcart.AjaxcartRender();
      }).catch(function(err) {
        /* uh oh, we have error. */
        console.error(err)
      });
    });
  },

}


$(document).ready(function() { 
  $(document).on('click', '.mm-ajaxcart-open', function(e) {
  	e.preventDefault();
    mmajaxcart.AjaxcartOpen();
    mmajaxcart.AjaxcartRender();
  })
  $(document).on('click', '.mm-ajaxcart-close', function(e) {
    e.preventDefault();
    mmajaxcart.AjaxcartClose();
  });
   $(document).on('click', '.mm-ajaxcart-overlay', function(e){
    e.preventDefault();
    mmajaxcart.AjaxcartClose();
  });
  
  mmajaxcart.AjaxcartRender();
  mmajaxcart.AjaxcartRemoveItem();
  mmajaxcart.AjaxcartQuantityHandler();
  mmajaxcart.Ajaxupsell();
  
  
})
